import jQuery from "jquery";

global.jQuery = jQuery;
global.$ = jQuery;
